var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "share_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".share_svg__st3{fill:#35a4dd}.share_svg__st14{fill:none;stroke:#35a4dd;stroke-width:65;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M257.8 409.5c56.2 0 101.9 45.7 101.9 101.9s-45.7 102-101.9 102-101.9-45.7-101.9-101.9 45.7-102 101.9-102m0-65c-92.2 0-166.9 74.7-166.9 166.9s74.7 166.9 166.9 166.9 166.9-74.7 166.9-166.9c.1-92.2-74.7-166.9-166.9-166.9zM766.2 751.4c56.2 0 101.9 45.7 101.9 101.9s-45.7 101.9-101.9 101.9-101.9-45.7-101.9-101.9S710 751.4 766.2 751.4m0-65c-92.2 0-166.9 74.7-166.9 166.9s74.7 166.9 166.9 166.9 166.9-74.7 166.9-166.9-74.7-166.9-166.9-166.9zM766.2 68.8c56.2 0 101.9 45.7 101.9 101.9s-45.7 101.9-101.9 101.9-101.9-45.7-101.9-101.9c-.1-56.2 45.7-101.9 101.9-101.9m0-65c-92.2 0-166.9 74.7-166.9 166.9S674 337.6 766.2 337.6s166.9-74.7 166.9-166.9S858.4 3.8 766.2 3.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M364 440.3l296.8-199M371 587.5l285.8 192.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default ForwardRef;